import { useGetAssignSurveyByIdQuery } from "../../../api/assignSurveyApi";

export default function useViewModal({ id }) {

    const { data, isSuccess, isFetching, refetch } = useGetAssignSurveyByIdQuery({ id: id });

    return {
        data,
        isSuccess : (isSuccess && !isFetching),
        refetch
    }
}